import * as React from 'react';
import {RouteComponentProps} from "react-router";
import {CreateBreadcrumb, IState} from "./Data";
import { EmailTemplateModel } from '../../model';
import { CreateLayout } from '../../layout/CreateLayout';
import { EmailTemplateForm } from './form';


export class CreateEmailTemplates extends React.Component<RouteComponentProps<{id?: string}>, IState> {
    
    constructor(props:RouteComponentProps) {
        super(props);
        this.state = {
            id: null,
            template: {} as EmailTemplateModel
        }
    }
    render() {
        return (
            <CreateLayout breadcrumb={CreateBreadcrumb} title={'Add new email template'}>
                <EmailTemplateForm {...this.state}/>
            </CreateLayout>
        )
    }
}
